export default __webpack_public_path__ + "static/media/right_pc.855ce445.png";